module.exports = __webpack_public_path__ + "2ed85eaecc53ae878c0669685fe58bc2.svg";